import React from "react"
import { RiErrorWarningLine } from "react-icons/ri"

import { isStorePaused, storePausedMessage } from "../../helpers/isStorePaused"

const SitewideBanner = () => {
  const storePaused = isStorePaused()

  if (!storePaused) return null

  return (
    <div className="sitewide-banner" role="status">
      <RiErrorWarningLine className="sitewide-banner__icon" />
      <span>{storePausedMessage}</span>
    </div>
  )
}

export default SitewideBanner
